<template>
  <v-card max-width="500px">
    <v-card-title class="subtitle-2">
      <v-icon>mdi-account-box-outline</v-icon>
      <span v-if="runEnded" class="ml-2">{{ customTitle || $t("live.activity.selfie.afterRun.title") }}</span>
      <span v-else class="ml-2">{{
        endEventMode
          ? $t("live.activity.selfie.beforeRun.endEvent.title")
          : customTitle || $t("live.activity.selfie.beforeRun.title")
      }}</span>
    </v-card-title>
    <v-card-text class="pb-0">
      <p v-if="runEnded">
        {{ customMessage || $t("live.activity.selfie.afterRun.message") }}
      </p>
      <p v-else>
        {{
          endEventMode
            ? $t("live.activity.selfie.before.endEvent.message")
            : customMessage || $t("live.activity.selfie.before.message")
        }}
      </p>
      <v-alert dense v-if="selfie" color="success" outlined class="body-2 pa-1">
        <v-icon color="success">mdi-check</v-icon>
        {{ $t("live.activity.selfie.success") }}
      </v-alert>
    </v-card-text>
    <v-card-actions class="mt-0 pa-3">
      <v-spacer />
      <v-btn v-if="!selfieUploadProgress || selfie" class="mr-1" color="secondary" text @click="continueClick()">
        {{ $t("live.activity.selfie.skip") }}
      </v-btn>
      <v-btn
        v-if="!selfie"
        color="primary"
        @click="$refs.selfieFileInput.click()"
        :disabled="!!selfieUploadProgress"
        :loading="!!selfieUploadProgress"
      >
        <v-icon class="mr-1">mdi-camera</v-icon>
        {{ $vuetify.breakpoint.mobile ? $t("live.activity.selfie.take") : $t("live.activity.selfie.upload") }}
      </v-btn>
      <ShareButton :selfie="selfie" @done="continueClick()" v-if="selfie" />
      <input v-show="false" @change="uploadSelfie" ref="selfieFileInput" type="file" accept="image/*" capture="user" />
    </v-card-actions>
    <v-progress-linear v-if="selfieUploadProgress" :value="selfieUploadProgress" />
  </v-card>
</template>

<script>
import ShareButton from "./share_button";

const getOrientedImage = require("exif-orientation-image");

export default {
  name: "ParticipantSelfie",
  props: {
    runEnded: Boolean,
    currentStepName: String,
    customMessage: String,
    customTitle: String,
    endEventMode: Boolean,
  },
  components: {
    ShareButton,
  },
  data() {
    return {
      selfieUploadProgress: null,
      selfie: null,
    };
  },
  methods: {
    async uploadSelfie() {
      this.selfieUploadProgress = 1;
      try {
        const formData = new FormData();
        let res = await this.resizeImage(this.$refs.selfieFileInput.files[0]);
        getOrientedImage(res, async (err, canvas) => {
          if (!err) {
            canvas.toBlob(
              (blob) => {
                res = new File([blob], res.name, {
                  type: "image/jpeg",
                  lastModified: Date.now(),
                });
              },
              "image/jpeg",
              1
            );
          }
          formData.append("file", res);
          formData.append("participantId", this.$store.state.participantId);
          formData.append("step", this.currentStepName);
          this.selfie = await this.$axios.post("/event/selfies", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (e) => (this.selfieUploadProgress = Math.round((100 * e.loaded) / e.total)),
          });
          this.$store.commit("ADD_SELFIE", this.selfie);

          this.$emit("selfieUploaded");
        });
      } catch (err) {
        this.selfieUploadProgress = null;
      }
    },
    resizeImage(file) {
      return new Promise((resolve) => {
        const maxSize = 2000;
        if (!file.type.match(/image.*/)) {
          resolve(file);
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (readerEvent) => {
          const img = new Image();
          img.src = readerEvent.target.result;
          img.onload = () => {
            const isVertical = img.height > img.width;
            const canvas = document.createElement("canvas");
            let width = img.width;
            let height = img.height;

            if (!isVertical) {
              if (img.width > maxSize) {
                width = maxSize;
                height *= maxSize / img.width;
              }
            } else {
              if (img.height > maxSize) {
                width *= maxSize / img.height;
                height = maxSize;
              }
            }

            canvas.width = width;
            canvas.height = height;

            const canvasCtx = canvas.getContext("2d");
            canvasCtx.drawImage(img, 0, 0, width, height);
            canvasCtx.canvas.toBlob(
              (blob) => {
                const parsedFile = new File([blob], file.name, {
                  type: "image/jpeg",
                  lastModified: Date.now(),
                });
                resolve(parsedFile);
              },
              "image/jpeg",
              0.9
            );
          };
        };
        reader.onerror = () => resolve(file);
      });
    },
    continueClick() {
      this.$emit("continue");
    },
  },
};
</script>

<style scoped></style>
